import {EventFamily, LibraryTopic} from '../entities';
import {Reducer} from 'redux';
import {IFetchPlaylistMw, ISetPlaylistMw, TPlaylistMw} from '../actions/playlists-mw.action';
import {ISetRemote, IUnsetRemote, TRemote} from '../actions';
import {environment} from '../../../environments/environment';


export interface IPlaylistMw {
  [key: string]: EventFamily;
}

export const defaultPlaylistMwState = {
  [0]: {
    id: 'scheduler',
    artwork: 'assets/icons/schedule.png',
    name: 'Schedule',
    libraryTopicType: LibraryTopic.EVENT,
    color: '#ffffff',
    path: ''
  }
};

const getPlaylistMw = (playlistMw) => ({
  ...playlistMw,
  mediasCount: playlistMw.tracks,
  eventsCount: playlistMw.playlists
});

export const playlistMwReducer: Reducer<IPlaylistMw> = (
  state: IPlaylistMw = defaultPlaylistMwState,
  action: ISetPlaylistMw | ISetRemote | IUnsetRemote | IFetchPlaylistMw
): IPlaylistMw => {
  switch (action.type) {
    case TRemote.SET_REMOTE:
      if (Object.keys(state).length > 0 && environment.enableDesktopMode) {
        return state;
      }
      // This to avoid a bug that overrides data on the library page
      if (!environment.enableDesktopMode) {
        return state;
      }
      return defaultPlaylistMwState;
    case TRemote.UNSET_REMOTE:
      return defaultPlaylistMwState;
    case TPlaylistMw.SET_PLAYLIST_MW:
      return action.payload
        .map(getPlaylistMw)
        .reduce((acc, p) => ({...acc, [p.id]: p}), state);
  }
  return state;
};
